/* global grecaptcha */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import classNames from 'classnames';
import RecaptchaHelper from '@/recaptchaHelper';

let recaptchaId;
let timer;

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        username: '',
        password: '',
      },
      isLogin: false,
    };
  }

  async componentDidMount() {
    await RecaptchaHelper.importRecaptcha();
    // There is a strange issue where the recaptchaTarget's <div> does not exist
    // if MyJobs is loaded at the root page, i.e. https://jobs.versafleet.co
    // If the auth/login page is loaded directly, i.e. https://jobs.versafleet.co/auth/login
    // then there is no issue. Unable to figure out the cause of this, so just force a refresh.
    if (this.recaptchaTarget === null) {
      window.location.reload();
    }
    timer = setInterval(this._createCaptcha, 500);
  }

  componentWillUnmount() {
    window.clearInterval(timer);
    if (recaptchaId) {
      grecaptcha.reset(recaptchaId);
    }
  }

  _createCaptcha = () => {
    try {
      if (grecaptcha !== undefined && grecaptcha.render !== undefined) {
        window.clearInterval(timer);
        recaptchaId = grecaptcha.render(this.recaptchaTarget,
          {
            sitekey: process.env.recaptchaSiteKey,
            callback: () => this._validateCaptchaAndLogin(),
            size: 'invisible',
          });
      }
    } catch {
      // ignore error and retry
    }
  }

  _onFormChange(fieldName, value) {
    this.setState(prevState => ({
      form: Utils.Helper.setFilter(prevState.form, fieldName, value),
    }));
  }

  _validateCaptchaAndLogin = async () => {
    this.setState({ isLogin: true });
    await this.props.dispatch(ReduxActions.profile.login({
      response: grecaptcha.getResponse(recaptchaId),
      customer: this.state.form,
    }));
    this.setState({ isLogin: false });
    grecaptcha.reset(recaptchaId);
  }

  _gotoProduction = () => {
    window.location.href = process.env.versafleetProduction;
  }

  render() {
    const loginButtonClassNames = classNames({
      'vf-authentication__login__content__body__button': true,
      'vf-authentication__login__content__body__button--visible':
        (this.state.form.username !== '' && this.state.form.password !== ''),
    });

    return (
      <div className="vf-authentication__login">

        <div className="vf-authentication__login__content">

          <div className="vf-authentication__login__content__intro">
            Login to MyJobs@VersaFleet™
          </div>

          <div className="vf-authentication__login__content__note">
            Submit new delivery orders to your VersaFleet™ logistics
            partner, and track ongoing ones.
          </div>

          <div className="vf-authentication__login__content__body">
            <Components.Input.Textbox
              autoComplete="username"
              onChange={value => this._onFormChange('username', value.trim())}
              placeholder="Your username "
              value={this.state.form.username}
            />
            <Components.Input.Textbox
              autoComplete="on"
              error={this.props.error}
              onChange={value => this._onFormChange('password', value)}
              onEnterKeyPressed={() => grecaptcha.execute(recaptchaId)}
              placeholder="Password"
              type="password"
              value={this.state.form.password}
            />
            <div ref={(recaptchaTarget) => { this.recaptchaTarget = recaptchaTarget; }} />
            <Components.Button
              className={loginButtonClassNames}
              color="GREEN"
              fillColor
              loading={this.state.isLogin}
              onClick={() => grecaptcha.execute(recaptchaId)}
            >
              Login
            </Components.Button>
          </div>
        </div>

        <a
          className="vf-authentication__login__redirect-link"
          onClick={this._gotoProduction}
        >
          Go to VersaFleet™
        </a>
      </div>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.arrayOf(PropTypes.string),
};

Login.defaultProps = {
  error: [],
};

function mapStateToProps(state) {
  const { profile } = state;
  return {
    error: profile.error || [],
  };
}

export default connect(mapStateToProps)(Login);
